export default __webpack_public_path__ + "static/media/basis-logo.d0f57413.png";